import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { safeReturnUrl } from '../../lib/url';

const LoginCallback = () => {
  const { session, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading) {
      if (session) {
        const params = new URLSearchParams(location.search);

        // Red-team SEC-01: never redirect to a query-provided foreign origin.
        const returnUrl = safeReturnUrl(
          params.get('returnUrl'),
          window.location.origin,
          '/'
        );

        // Use window.location so an absolute same-origin returnUrl works.
        window.location.replace(returnUrl);
      } else {
        navigate('/login', { replace: true });
      }
    }
  }, [session, loading, navigate, location]);

  if (loading) return <p>Processing login...</p>;

  return <p>Completing login...</p>;
};

export default LoginCallback;
